// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedContentSidebar-cls1__3X","cls2":"SuggestedContentSidebar-cls2_xn9 SuggestedContentSidebar-cls1__3X"};